import React, { Component } from 'react';
import { TouchableOpacity, Text, Modal, View, ImageBackground } from 'react-native';
import PPLogUtil from '../../Utils/PPLogUtil';
import styles from './style';

interface Props {
    isVisible: boolean;
    popData:any;
    onOk?(jumpUrl:string): void;
    onCancel?(): void;
}

class OrderWxPopup extends Component<Props> {
    // public onMaskTap = () => {};
    
    componentDidMount(){
        PPLogUtil.orderWxPopup('show','OrderWxPopup',{});
    }
    public render() {
        const { isVisible, onOk, onCancel, popData } = this.props;
        const { orderType, orderDetail, bgImgUrl, jumpUrl} = popData || {};
        return (
            <Modal
                visible={isVisible}
                transparent
                hardwareAccelerated
                animationType="fade"
                onRequestClose={() => onCancel?.()}
            >
                <View style={styles.confirmWrapper}>
                    <TouchableOpacity
                        activeOpacity={1}
                        style={styles.modalWrap}
                        onPress={() => {
                            onOk?.(jumpUrl);
                            PPLogUtil.orderWxPopup('click','OrderWxPopup',{});
                        }}
                    >
                        <ImageBackground
                            source={{ uri: bgImgUrl }}
                            style={{width:'100%',height:'100%'}}
                        >
                            <View>
                                {orderType?(
                                    <View style={styles.cardWrap}>
                                        <View style={styles.textWrap}>
                                            <Text style={styles.typeKey}>订单类型：</Text>
                                            <Text style={styles.typeValue}>{orderType}</Text>
                                        </View>
                                        <View style={[styles.textWrap,{marginTop:4}]}>
                                            <Text style={styles.typeKey}>订单详情：</Text>
                                            <Text style={[styles.typeValue,{ width: 160}]} numberOfLines={2} ellipsizeMode="tail">{orderDetail}</Text>
                                        </View>
                                    </View>
                                ):(
                                    <View style={styles.cardWrap}>
                                        <View style={styles.textWrap}>
                                            <Text style={styles.typeValue} numberOfLines={3} ellipsizeMode="tail">{orderDetail}</Text>
                                        </View>
                                    </View>
                                )}
                                
                                <View style={styles.closeWrap}>
                                    <TouchableOpacity
                                        activeOpacity={1}
                                        style={styles.closeBtn}
                                        onPress={() => onCancel?.()}
                                    ></TouchableOpacity>
                                </View>
                            </View>
                        </ImageBackground>
                    </TouchableOpacity>
                </View>
            </Modal>
        );
    }
}

export default OrderWxPopup;
